export function visualGamePreviewUrl(adminOrigin) {
  const adminUrl = new URL(adminOrigin)

  if (adminUrl.hostname === 'localhost' || adminUrl.hostname === '127.0.0.1') {
    return new URL('http://localhost:5182/game')
  }

  if (!adminUrl.hostname.startsWith('admin-')) {
    throw new Error(`Visual Game Admin hostname must start with admin-: ${adminUrl.hostname}`)
  }

  adminUrl.hostname = adminUrl.hostname.slice('admin-'.length)
  adminUrl.pathname = '/game'
  adminUrl.search = ''
  adminUrl.hash = ''
  return adminUrl
}
